import { render, staticRenderFns } from "./task-comments-attachment.vue?vue&type=template&id=ecd1b5b4&scoped=true&"
import script from "./task-comments-attachment.vue?vue&type=script&lang=js&"
export * from "./task-comments-attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd1b5b4",
  null
  
)

export default component.exports